import { Component, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ensureHttps } from '../setup/utils';

@Component({
  selector: 'app-prosemirror-link-modal',
  templateUrl: './prosemirror-link-modal.component.html',
  styleUrls: ['./prosemirror-link-modal.component.scss'],
})
export class ProsemirrorLinkModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  link: string;

  close() {
    this.activeModal.close(ensureHttps(this.link));
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  @HostListener('document:keyup.enter')
  handleEnter() {
    this.close();
  }
}
